require("dotenv").config();
import axios from "axios";

const apiURL = `${process.env.VUE_APP_MASTER_API_URL}/integrations`;

class IntegrationService {
  // Get the registry of all supported providers
  static GetRegistry() {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios
              .get(`${apiURL}/registry`, {
                withCredentials: true,
              })
              .then(
                (response) => response.data,
                (error) => error.response.data,
              );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })(),
      );
    });
  }

  // List connected integrations for the company
  static ListIntegrations() {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios
              .post(`${apiURL}/list`, {}, {
                withCredentials: true,
              })
              .then(
                (response) => response.data,
                (error) => error.response.data,
              );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })(),
      );
    });
  }

  // Connect an API key provider
  static Connect(data) {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios
              .post(`${apiURL}/connect`, data, {
                withCredentials: true,
              })
              .then(
                (response) => response.data,
                (error) => error.response.data,
              );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })(),
      );
    });
  }

  // Start OAuth flow
  static OAuthStart(data) {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios
              .post(`${apiURL}/oauth/start`, data, {
                withCredentials: true,
              })
              .then(
                (response) => response.data,
                (error) => error.response.data,
              );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })(),
      );
    });
  }

  // Disconnect a provider
  static Disconnect(data) {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios
              .post(`${apiURL}/disconnect`, data, {
                withCredentials: true,
              })
              .then(
                (response) => response.data,
                (error) => error.response.data,
              );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })(),
      );
    });
  }

  // Toggle active/inactive
  static Toggle(data) {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios
              .post(`${apiURL}/toggle`, data, {
                withCredentials: true,
              })
              .then(
                (response) => response.data,
                (error) => error.response.data,
              );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })(),
      );
    });
  }
}

export default IntegrationService;
